import { createAsyncThunk, createSlice, createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import http from '../../../lib/http/index.js';

export const getIndices = createAsyncThunk('GET_INDICES', async (payload, thunkAPI) => {
        const res = (await http.TABLE('/indices')).body;
        return res
});
export const addIndice = createAsyncThunk('POST_INDICES', async (payload, thunkAPI) => {
    let res = (await http.POST('/indices', payload));
    await thunkAPI.dispatch(getIndices()).unwrap();
    return res;
});
export const editIndice = createAsyncThunk('PUT_INDICES', async (payload, thunkAPI) => {
    const res = (await http.PUT('/indices', payload));
    await thunkAPI.dispatch(getIndices()).unwrap();
    return res

});
export const deleteIndice = createAsyncThunk('DELETE_INDICES', async (payload, thunkAPI) => {
    const res = (await http.DELETE('/indices', payload))
    await thunkAPI.dispatch(getIndices()).unwrap();
    return res

});
const initialState = {
    //pendingRequests: 0,
    fetching: 0,
    error: null,
    message: null,
    data: []
};

const indicesSlice = createSlice({
    name: 'indices',
    initialState,
    reducers: {
        cleanError: (state, action) => ({ ...state, error: null }),
        cleanMessage: (state, action) => ({ ...state, message: null }),
        resetData: (state, action) => ({ ...initialState }),
    },
    extraReducers: {
        [getIndices.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, error: null, message: null }),
        [getIndices.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: action }),
        [getIndices.fulfilled]: (state, action) => ({ ...state, data: action.payload, fetching: state.fetching - 1 }),

        [addIndice.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1 }),
        [addIndice.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la creación!" }),
        [addIndice.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Índice creado!" : null,
            error: action.payload.status != 200 ? "No se pudo crear el Índice!" : null,
        }),
        [editIndice.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, detallesBatch: null, error: null, message: null }),
        [editIndice.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la edición!" }),
        [editIndice.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Índice editado!" : null,
            error: action.payload.status != 200 ? "No se pudo editar el Índice!" : null,
        }),

        [deleteIndice.pending]: (state, action) => ({ ...state, fetching: state.fetching + 1, cuponesRegistro: null, error: null, message: null }),
        [deleteIndice.rejected]: (state, action) => ({ ...state, fetching: state.fetching - 1, error: "No se pudo procesar la eliminación!" }),
        [deleteIndice.fulfilled]: (state, action) => ({
            ...state,
            fetching: state.fetching - 1,
            message: action.payload.status === 200 ? "Índice eliminado!" : null,
            error: action.payload.status != 200 ? "No se pudo eliminar el Índice!" : null,
        })
    },
})

export const { cleanError, cleanMessage, resetData } = indicesSlice.actions
export default indicesSlice.reducer;